/**
 * Avatar
 * Renders a circular initial-based avatar.
 *
 * Props:
 *   name  – display name (first letter used)
 *   email – fallback if name is empty
 *   size  – diameter in px (default 52)
 */
export default function Avatar({ name, email, size = 52 }) {
  const letter = (name?.[0] ?? email?.[0] ?? "?").toUpperCase();
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: "linear-gradient(135deg, #1e40af, #2563eb)",
      color: "#fff", fontSize: size * 0.38, fontWeight: 700,
      display: "flex", alignItems: "center", justifyContent: "center",
      flexShrink: 0, boxShadow: "0 2px 8px rgba(37,99,235,0.25)",
    }}>
      {letter}
    </div>
  );
}